import React from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import MenuItems from "./MenuItems";
import HeaderImage from "../../Images/HomePage/Header.jpg";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  Image: {
    width: "100%",
  },
}));

function Copyright() {
  return (
    <div style={{ paddingTop: "1%" }}>
      <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © Flintston & Karishma "}
        <br />
        <Link color="inherit" href="https://businessprovider.co.za">
          Business Providers @ Your Service
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    </div>
  );
}

export default function HomePage() {
  const classes = useStyles();

  return (
    <>
      <Box my={0}>
        <img src={HeaderImage} className={classes.Image} />
        <MenuItems />
        <Copyright />
      </Box>
      <Box paddingTop={1} my={0}></Box>
    </>
  );
}
